import { DataSource } from '@models';

export const preProcess = (data: DataSource) => {
  const cronValue = data.incrementalImportCron;

  if (cronValue === undefined || cronValue === null) return data;

  const trimmedValue = cronValue.trim();

  return {
    ...data,
    incrementalImportCron: trimmedValue ? trimmedValue : null,
  };
};
